import { render, staticRenderFns } from "./YamaGameStage.vue?vue&type=template&id=287b944f&scoped=true&"
import script from "./YamaGameStage.vue?vue&type=script&lang=js&"
export * from "./YamaGameStage.vue?vue&type=script&lang=js&"
import style0 from "./YamaGameStage.vue?vue&type=style&index=0&id=287b944f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "287b944f",
  null
  
)

export default component.exports